var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#FF4F4F",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7931 18.595C17.4955 16.9902 18.7819 15.7414 20.3692 15.1232C21.9565 14.505 23.7148 14.5681 25.2575 15.2985C26.7999 16.0294 28.0002 17.3677 28.5944 19.0191C29.1885 20.6706 29.1279 22.5 28.4259 24.105C27.9196 25.2678 27.1015 26.2539 26.0697 26.9449C25.038 27.6358 23.8365 28.0022 22.6095 28C20.1441 28 17.8888 26.518 16.8296 24.2H8V22.3C8.05479 21.217 8.767 20.3335 10.1366 19.621C11.5063 18.9085 13.2229 18.538 15.3047 18.5C15.8252 18.5 16.3183 18.5475 16.7931 18.595ZM15.3047 9C16.3274 9.0285 17.1857 9.399 17.8705 10.1115C18.5554 10.824 18.8932 11.717 18.8932 12.8C18.8932 13.883 18.5554 14.776 17.8705 15.4885C17.1857 16.201 16.3274 16.5525 15.3047 16.5525C14.2821 16.5525 13.4238 16.201 12.739 15.4885C12.0541 14.776 11.7163 13.883 11.7163 12.8C11.7163 11.717 12.0541 10.824 12.739 10.1115C13.4238 9.399 14.2821 9.0285 15.3047 9ZM22.6095 26.1C23.8203 26.1 24.9816 25.5995 25.8378 24.7087C26.6939 23.818 27.1749 22.6098 27.1749 21.35C27.1749 20.0902 26.6939 18.882 25.8378 17.9912C24.9816 17.1004 23.8203 16.6 22.6095 16.6C21.3986 16.6 20.2374 17.1004 19.3812 17.9912C18.525 18.882 18.044 20.0902 18.044 21.35C18.044 22.6098 18.525 23.818 19.3812 24.7087C20.2374 25.5995 21.3986 26.1 22.6095 26.1ZM21.6964 18.5H23.066V21.179L25.294 22.5185L24.6092 23.7535L21.6964 22.0055V18.5Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsFrame4);
export default __webpack_public_path__ + "static/media/stats_frame_4.e901cbd291cae649b9d77fd0b8e5120e.svg";
export { ForwardRef as ReactComponent };